import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect, useRef } from 'react'

import { updateFormDataField } from 'cng-common/features/form'

const PROGRESS_FIELDS = ['currentProgress', 'followUp'] as const

interface IUseResetProgressOnPracticeDevelopmentExitParams {
  initiativeFormKey: string
  isPracticeDevelopment: boolean
}

export const useResetProgressOnPracticeDevelopmentExit = ({
  initiativeFormKey,
  isPracticeDevelopment,
}: IUseResetProgressOnPracticeDevelopmentExitParams) => {
  const dispatch = useAppDispatch()
  const previousIsPracticeDevelopmentRef = useRef(isPracticeDevelopment)

  useEffect(() => {
    const wasPracticeDevelopment = previousIsPracticeDevelopmentRef.current
    previousIsPracticeDevelopmentRef.current = isPracticeDevelopment

    if (!wasPracticeDevelopment || isPracticeDevelopment) {
      return
    }

    PROGRESS_FIELDS.forEach((field) => {
      dispatch(
        updateFormDataField({
          field,
          value: '',
          formKey: initiativeFormKey,
        })
      )
    })
  }, [dispatch, initiativeFormKey, isPracticeDevelopment])
}
